import { brandSecondary } from '../../../../styles/colors';
import { CssSelectors } from '../../../../styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	body: {
		marginTop: 40,
		textAlign: 'center',
		...CssSelectors.allChildren(
			{
				marginTop: 30,
			},
			':not(:first-child)'
		),
	},
	container: {
		paddingBottom: 30,
		width: 400,
	},
	downloadButton: {
		display: 'inline-block',
		margin: '0 auto',
		textDecoration: 'none',
	},
	footer: {
		marginTop: 30,
		textAlign: 'center',
	},
	header: {
		color: brandSecondary,
		fontSize: 18,
	},
	icon: {
		boxShadow: '0 2px 4px 0 rgba(171,171,171,0.50)',
		display: 'block',
		margin: '0 auto',
	},
});
